// extracted by mini-css-extract-plugin
export default {"playIcon":"PlayIcon_playIcon__59jar","active":"PlayIcon_active__YWr13"};